export const normalizeCreative = ({ image_url, title, text }) =>
  typeof image_url === 'string'
    ? {
        image_url: [image_url],
        title: [title],
        text: [text]
      }
    : { image_url, title, text };
